import React, { useState, useEffect } from "react";
import "./CardList.css";
import Header from "../common/Header";
import httpService from "../../services/HttpService";

const CardList = () => {
    const [cards, setCards] = useState([]);

    useEffect(() => {
        const fetchCards = async () => {
            try {
                const data = await httpService.get("/cards");
                setCards(data);
            } catch (error) {
                console.error("Error fetching cards:", error);
            }
        };

        fetchCards();
    }, []);

    const handleDelete = async (cardId) => {
        try {
            await httpService.delete(`/cards/${cardId}`);
            setCards(cards.filter(card => card.id !== cardId));
        } catch (error) {
            console.error("Error deleting card:", error);
        }
    };

    return (
        <>
            <Header />
            <div className="cl-page">
                <div className="cl-page-container">
                    <div className="cl-page-title">Карты</div>
                    <div className="pp-card-list-container">
                        {cards?.length && cards.map((card, index) => (
                            <div key={index} className="pp-card-container">
                                <span className="material-symbols-sharp pp-card-icon">credit_card</span>
                                <span className="pp-card-pan">Карта **** {card.masked_pan.slice(-4)}</span>
                                <span
                                    className="material-symbols-sharp cl-card-delete"
                                    onClick={() => handleDelete(card.id)}
                                >
                                delete
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
                {/*<button className="default-button cl-add-button">*/}
                {/*    Добавить карту*/}
                {/*</button>*/}
            </div>
        </>
    );
};

export default CardList;
